import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/config';
import { Observable } from 'rxjs';
import { MeterPrice } from '../models/meterPrice.model';

@Injectable({
  providedIn: 'root'
})
export class MeterPriceService {
  
  private pathApi = this.config.setting['pathApi'] + "meterPrice/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn);
  }

  save(meterPrice: MeterPrice): Observable<any> {
    return this.http.post(`${this.pathApi}save`, meterPrice);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  }
}
